var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoodunclesWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,24.2c0-1.5-1-2.1-2.7-2.1h-1.9l-1.9,9c-0.6,2.7-1.8,3.6-3.3,3.6c-1.3,0-2.2-0.5-2.2-2.1 c0-0.4,0.1-0.8,0.1-1.2l1.3-6c0.1-0.5,0.1-0.9,0.1-1.2c0-1.5-0.9-2-2.7-2h-2l-1.9,9c-0.2,0.9-0.2,1.7-0.2,2.5c0,3.3,2.8,5.4,6.9,5.4 c6.9,0,8.4-5.1,9-7.6l1.3-6C32,24.8,32,24.5,32,24.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,13.7c0,2.7-1.1,5.1-3.4,5.1c-0.6,0-2.3-0.2-2.3-2.5c0-2.7,1.1-5.2,3.5-5.2C21.9,11.1,23.4,11.3,23.4,13.7 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,13.7c0,2.7-1.1,5.1-3.4,5.1c-0.6,0-2.3-0.2-2.3-2.5c0-2.7,1.1-5.2,3.5-5.2C31.6,11.1,33.2,11.3,33.2,13.7 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoodunclesWhite);
export default __webpack_public_path__ + "static/media/ic-gooduncles-white.a59c4364e8ab5c8f8f93091bfc6219ad.svg";
export { ForwardRef as ReactComponent };